import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setCategoryList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";

AxiosCurlirize(axios, () => {});
export const useCategoryListingAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (pageSize: number, pageNumber: number, query: string = "") => {
      dispatch(setLoading({ key: "isInventoryProductListLoadingInProgess", status: true }));
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const url =
          query.trim() !== ""
            ? `${COUPON_SERVICE_APIS?.COUPON_VMS_CATEGORY?.baseURL}?search_keyword=${encodeURIComponent(query)}`
            : `${COUPON_SERVICE_APIS?.COUPON_VMS_CATEGORY?.baseURL}?page=${pageSize}&page_size=${pageNumber}`;

        const res = await axios.get(url, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        dispatch(setLoading({ key: "isInventoryProductListLoadingInProgess", status: false }));
        if (res.data.status === true) {
          dispatch(setCategoryList(res.data.data));
        } else {
          dispatch(setCategoryList({ data: [], item_count: 0 }));
        }
      } catch (e: any) {
        captureError(e);
        sendCurl(e.config["curlCommand"]);
        dispatch(setLoading({ key: "isInventoryProductListLoadingInProgess", status: false }));
        dispatch(setCategoryList({ data: [], item_count: 0 }));
      }
    },
    [dispatch],
  );

  return { execute };
};
